module.exports = __webpack_public_path__ + "static/galindo-6784cadffb46e15f39697d432a6833d0.png";